/*// =require pastel3/vendor/jquery.tmpl.min.js*/
/*global Shopify */

/**
 * Module to show Recently Viewed Products
 *
 * Copyright (c) 2014 Caroline Schnapp (11heavens.com)
 * Dual licensed under the MIT and GPL licenses:
 * http://www.opensource.org/licenses/mit-license.php
 * http://www.gnu.org/licenses/gpl.html
 *
 */

Shopify.Products = (function() {

    var config = {
        howManyToShow: 3,
        howManyToStoreInMemory: 10,
        wrapperId: 'recently-viewed-products',
        templateId: 'recently-viewed-product-template',
        onComplete: null
    };

    var productHandleQueue = [];
    var wrapper = null;
    var template = null;
    var shown = 0;

    var cookie = {
        configuration: {
            expires: 90,
            path: '/',
            domain: window.location.hostname
        },
        name: 'shopify_recently_viewed',
        write: function(recentlyViewed) {
            jQuery.cookie(this.name, recentlyViewed.join(' '), this.configuration);
        },
        read: function() {
            var recentlyViewed = [];
            var cookieValue = jQuery.cookie(this.name);
            if (cookieValue !== null) {
                recentlyViewed = cookieValue.split(' ');
            }
            return recentlyViewed;
        },
        destroy: function() {
            jQuery.cookie(this.name, null, this.configuration);
        },
        remove: function(productHandle) {
            var recentlyViewed = this.read();
            var position = jQuery.inArray(productHandle, recentlyViewed);
            if (position !== -1) {
                recentlyViewed.splice(position, 1);
                this.write(recentlyViewed);
            }
        }
    };

    var finalize = function() {
        wrapper.show();
        // If we have a callback.
        if (config.onComplete) {
            try { config.onComplete() } catch (error) { }
        }
    };

    var moveAlong = function() {
        if (productHandleQueue.length && shown < config.howManyToShow) {
            jQuery.ajax({
                dataType: 'json',
                url: '/products/' + productHandleQueue[0] + '.js',
                cache: false,
                success: function(product) {
                    if (product.images.length) {
                        template.tmpl(product).appendTo(wrapper);
                    }
                    productHandleQueue.shift();
                    shown++;
                    moveAlong();
                },
                error: function() {
                    cookie.remove(productHandleQueue[0]);
                    productHandleQueue.shift();
                    moveAlong();
                }
            });
        }
        else {
            finalize();
        }

    };

    return {

        resizeImage: function(src, size) {
            if (size == null) {
                return src;
            }

            if (size == 'master') {
                return src.replace(/http(s)?:/, "");
            }

            var match  = src.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?/i);

            if (match != null) {
                var prefix = src.split(match[0]);
                var suffix = match[0];

                return (prefix[0] + "_" + size + suffix).replace(/http(s)?:/, "")
            } else {
                return null;
            }
        },

        showRecentlyViewed: function(params) {

            params = params || {};

            // Update defaults.
            jQuery.extend(config, params);

            // Read cookie.
            productHandleQueue = cookie.read();

            // Remove current page from list
            var phq = productHandleQueue;
            var productHandle = this.getProductHandle();
            if (phq.indexOf(productHandle) > -1) {
                phq.splice(phq.indexOf(productHandle), 1);
            }

            // Template and element where to insert.
            template = jQuery('#' + config.templateId);
            wrapper = jQuery('#' + config.wrapperId);

            // How many products to show.
            config.howManyToShow = Math.min(phq.length, config.howManyToShow);

            // If we have any to show.
            if (config.howManyToShow && template.length && wrapper.length) {
                // Getting each product with an Ajax call and rendering it on the page.
                moveAlong();
            }

        },

        getProductHandle: function() {
            return window.location.pathname.match(/\/products\/([a-z0-9\-]+)/)[1];
        },

        getConfig: function() {
            return config;
        },

        clearList: function() {
            cookie.destroy();
        },

        recordRecentlyViewed: function(params) {

            params = params || {};

            // Update defaults.
            jQuery.extend(config, params);

            // Read cookie.
            var recentlyViewed = cookie.read();

            // If we are on a product page.
            if (window.location.pathname.indexOf('/products/') !== -1) {

                // What is the product handle on this page.
                var productHandle = this.getProductHandle();
                // In what position is that product in memory.
                var position = jQuery.inArray(productHandle, recentlyViewed);
                // If not in memory.
                if (position === -1) {
                    // Add product at the start of the list.
                    recentlyViewed.unshift(productHandle);
                    // Only keep what we need.
                    recentlyViewed = recentlyViewed.splice(0, config.howManyToStoreInMemory);
                }
                else {
                    // Remove the product and place it at start of list.
                    recentlyViewed.splice(position, 1);
                    recentlyViewed.unshift(productHandle);
                }

                // Update cookie.
                cookie.write(recentlyViewed);

            }

        }

    };

})();
jQuery.fn.extend({
    myfancy: function(){
        console.log('myfancy');
    }
});

$(document).ready(function(){

    // Change product variant by select
    $("#colorSelector").change(function(){
        var $mainPicture = $('#main_picture');

        // Update picture
        if ($(this).val()) {
            var $variantPicture = $('.product_thumbnail[data-variant-id=' + $(this).val() + ']');

            // Set variant picture if found or default picture if not
            if ($variantPicture.length) {
                $mainPicture.attr('src', $variantPicture.attr('href'));
            } else {
                $mainPicture.attr('src', $mainPicture.data('default-src'));
            }
        } else {
            $mainPicture.attr('src', $mainPicture.data('default-src'));
        }

        var $quantitySelector = $('#quantitySelector'),
            $selectedOption = $(this).find('option:selected'),
            $submitButton = $('#submit_button'),
            $submitButtonParent = $submitButton.parent(),
            $productSku = $('#productSku'),
            stockMessage = 'In stoc',
            buttonMessage = 'Adauga in cos',
            buttonEnabled = true,
            wrapperEnabled = true,
            inventory = 15,
            inventory_policy = 'continue';

        // Update button and stock message
        //if ($selectedOption.attr('inventory') !== undefined) {
        if ($selectedOption.attr('inventory_policy') !== undefined) {
            //inventory = parseInt($selectedOption.attr('inventory'), 10);
            inventory_policy = $selectedOption.attr('inventory_policy');

            //if (!inventory) {
            if (inventory_policy == 'deny') {
                stockMessage = 'Indisponibil';
                buttonMessage = 'Produs indisponibil';
                buttonEnabled = false;
            } else {
                if (inventory > 15) {
                    inventory = 15;
                }
            }
        } else {
            stockMessage = '&nbsp;';
            buttonMessage = 'Selecteaza optiunile';
            buttonEnabled = wrapperEnabled = false;
        }

        $(".stockAvability").html(stockMessage);
        $submitButton.val(buttonMessage);

        if (buttonEnabled) {
            $submitButton.removeClass("disabled");
        } else {
            $submitButton.addClass("disabled");
        }

        if (wrapperEnabled) {
            $submitButtonParent.removeClass('disabled must_select');
        } else {
            $submitButtonParent.addClass('disabled must_select');
        }


        // Update SKU
        $productSku.html($selectedOption.attr('sku'));

        // Update history state for product deeplinking
        if (history.replaceState) {
            var newurl =
                window.location.protocol +
                '//' +
                window.location.host +
                window.location.pathname;

            if ($selectedOption.attr('variant_id')) {
                newurl += '?variant=' + $selectedOption.attr('variant_id');
            }

            window.history.replaceState({ path: newurl }, '', newurl);
        }

        // Update quantity selector
        $quantitySelector.children().remove();
        for (var i = 1; i <= inventory; i++) {
            $quantitySelector.append($('<option>', { value: i, text: i }));
        }
    }).change();

    // Change product variant by thumb
    $('.product_thumbnail').click(function(){
        $('#colorSelector').val($(this).data('variant-id')).change();

        return false;
    });

    // Add to cart
    $("#addToCartForm").on("submit", function() {
        var $quantity = $("#addToCartForm").find('[name=quantity]');

        if (!parseInt($quantity.val(), 10)) {
            $quantity.val(1).change();
        }

        cartAdd($('form[action="/cart/add"]').serialize());

        return false;
    });

    // Estimated delivery date
    var $estimatedDelivery = $('#estimatedDelivery');
    if($estimatedDelivery.length) {
        var d = new Date(),
            weekDays = ['Duminica', 'Luni', 'Marti', 'Miercuri', 'Joi', 'Vineri', 'Sambata'];

        d.setDate(d.getDate() + 6);
        $estimatedDelivery.find('span').html(
            weekDays[d.getDay()]
            + ' ' + ("0" + d.getDate()).slice(-2)
            + '.' + ("0" + (d.getMonth() + 1)).slice(-2)
            + '.' + d.getFullYear()
        );
    }

    Shopify.Products.showRecentlyViewed({
        howManyToShow: 10,
        onComplete: function() {
            $('.produse_recente').lightSlider({
                item:3,
                vertical:true,
                verticalHeight:260,
                slideMargin:0,
                pager: false,
                loop: true
            });
        }
    });

    Shopify.Products.recordRecentlyViewed();
});

$('.fb-comments').attr('data-href', $('.product-link').attr('href'));

$(".reviews-tab").click(function () {
    $(".product-tabs li").removeClass("active");
    $(this).addClass("active");
    $(".full-describe-section").css('height', '0');
    $(".reviews-section").css('height', 'auto');
});
$(".full-describe-tab").click(function () {
    $(".product-tabs li").removeClass("active");
    $(this).addClass("active");
    $(".reviews-section").css('height', '0');
    $(".full-describe-section").css('height', 'auto');
});

/*
$('#productLongDescription a').attr('href', "#totext");
$('#productLongDescription a').click(function (){
    $(".product-tabs li").removeClass("active");
    $(".full-describe-tab").addClass("active");
    $(".reviews-section").css('height', '0');
    $(".full-describe-section").css('height', 'auto');
});
*/

$('#productLongDescription a').on('click', function() {
    $('#productLongDescription .col-xs-12').css('height', 'auto');
    $(this).hide(0);
});
